'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import getLang from 'I18n/utils/getLang';
import { createContext, useMemo, useState } from 'react';
const LocaleContext = /*#__PURE__*/createContext({
  locale: ''
});
export const LocaleContextProvider = ({
  children
}) => {
  const [locale, setLocale] = useState(getLang());
  const contextValue = useMemo(() => {
    return {
      locale,
      setLocale
    };
  }, [locale]);
  return /*#__PURE__*/_jsx(LocaleContext.Provider, {
    value: contextValue,
    children: children
  });
};
export default LocaleContext;